@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.linkButton {
  @include border-radius-r2;
  background: var(--action-primary-default);
}

.main {
  flex-grow: 1;
}

.notFoundSection {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 100vh;
}

.title {
  @include typography-v2-title-xl;
}

.description {
  @include typography-v2-body-md;
}

.animationContainer {
  width: 240px;
  height: 180px;
  display: flex;
  justify-self: center;
}
